module.exports = __webpack_public_path__ + "img/pest.old.97ad2648.png";